<template>
  <div class="status-container" :style="{ width: width }">
    <div class="step-container" v-for="(step, index) in steps" :key="index">
      <div class="circle-container">
        <div class="icon-container">
          <div v-if="index > 0" class="bar" :class="[isActive(index) ? 'active': '']"></div>
          <div class="circle" :class="[isActive(index) ? 'active': '']">
            <feather-icon v-if="isActive(index)"  icon="CheckIcon" svgClasses="h-5 w-5"/>
            <div v-else>{{ index + 1}}</div>
            <div class="icon-label" :class="[isActive(index) ? 'active': '']">{{ step }}</div>
          </div>
          <div v-if="index < steps.length - 1" class="bar" :class="[isActive(index + 1) ? 'active': '']"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StatusStep930',
  props: {
    /**
     * 현재 상태를 나타내는 숫자입니다.
     * 0: 아무것도 아님
     * 1: 등록
     * 2: 입문
     * 3: 작업중
     * 4: 작업완료
     * 5: 출문
     */
    status: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: '500px',
    }
  },
  data() {
    return {
      steps: ['등록', '입문', '작업중', '작업완료', '출문 ']
    };
  },

  methods: {
    isActive(index) {
      return index < this.status;
    }
  }
}
</script>


<style scoped lang="scss">
.status-container {
  display: flex;

  .step-container {
    display: flex;
    flex-direction: row;
    align-items: center;

    .bar {
      width: 50px;
      height: 2px;
      background-color: #bdbdbd;
    }
    .bar.active {
      background-color: rgba(var(--vs-secondary));
    }


    .circle-container {
      display: flex;
      flex-direction: column;
      text-align: center;

      .icon-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 0 50px;

        .circle {
          width: 32px;
          height: 32px;
          background-color: #bdbdbd;
          color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .icon-label {
            color: #82868b;
            position: absolute;
            bottom: -30px;
            width: 100px;
          }
          .icon-label.active {
            color: #2c2c2c;
          }
        }
        .circle.active {
          background-color: rgba(var(--vs-secondary));
        }
      }
    }
  }
}
</style>
